import { Box, withCitrusTheme } from '@gousto-internal/citrus-react'

export const BoxSummaryPickerContainer = withCitrusTheme(Box, (theme) => ({
  '&:focus': {
    outline: 'none',
    border: `2px solid ${theme.tokens.colors.Secondary_600}`,
    borderRadius: '2px',
  },
}))
